import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/utils/create-styled-context.tsx
import React, {
  createContext,
  createElement,
  forwardRef,
  useContext,
  useMemo
} from "react";
var splitProps = (keys, props) => {
  const keyProps = {};
  const otherProps = {};
  for (const [key, value] of Object.entries(props)) {
    if (keys.includes(key)) {
      keyProps[key] = value;
      continue;
    }
    otherProps[key] = value;
  }
  return [keyProps, otherProps];
};
var createStyleContext = (recipe) => {
  const StyleContext = createContext({ slotStyles: null, classes: {} });
  const withProvider = (Component, slot, defaultProps) => {
    const StyledComponent = forwardRef(({ classes = {}, unstyled = false, ...props }, ref) => {
      const [variantProps, otherProps] = splitProps(recipe.variantKeys, {
        ...defaultProps,
        ...props
      });
      const slotStyles = useMemo(
        () => recipe(variantProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Object.values(variantProps)
      );
      return /* @__PURE__ */ React.createElement(StyleContext.Provider, { value: { slotStyles, classes, unstyled } }, /* @__PURE__ */ React.createElement(
        Component,
        {
          ref,
          ...otherProps,
          className: unstyled ? props.className : slotStyles[slot]({
            className: cn(classes[slot], props.className)
          })
        }
      ));
    });
    return StyledComponent;
  };
  const withContext = (Component, slot, defaultProps) => {
    const StyledComponent = forwardRef(({ unstyled: unstyledProp, ...props }, ref) => {
      const { slotStyles, classes, unstyled } = useContext(StyleContext);
      const el = createElement(Component, {
        ...defaultProps,
        ...props,
        className: unstyled || unstyledProp ? props.className : slotStyles?.[slot]({
          className: cn(classes[slot], props.className)
        }),
        ref
      });
      return el;
    });
    return StyledComponent;
  };
  return {
    withProvider,
    withContext
  };
};

export {
  splitProps,
  createStyleContext
};
